import * as TimeseriesTemplate from "./timeseries";
import * as ScatterplotTemplate from "./scatterplot";
import * as TextTemplate from "./text";
import * as CommentTemplate from "./comment";
import * as AverageLossesPresetTemplate from "./average-losses-preset";
import * as ProductionMonitoringPresetTemplate from "./production-monitoring-preset";
import * as PriorityFaultEventsPresetTemplate from "./priority-fault-events-preset";
import * as CostImpactPresetTemplate from "./costImpactPreset";
import * as AnomalyDetectionLastWeekAlerts from "./anomaly-detection-last-week-alerts";

import { Level2HeadingTemplate, Level3HeadingTemplate, Level4HeadingTemplate } from "./heading";
import t from "../../../../../../../../../i18n";
import { ImageTemplate } from "./image";
import { DiagramTemplate } from "./diagram";

export const customTemplates = [
  {
    title: t("project.dashboard.block.template.category.plot"),
    options: [TimeseriesTemplate, ScatterplotTemplate],
  },
  {
    title: t("project.dashboard.block.template.category.visual"),
    options: [ImageTemplate, DiagramTemplate],
  },
  {
    title: t("project.dashboard.block.template.category.text"),
    options: [
      Level2HeadingTemplate,
      Level3HeadingTemplate,
      Level4HeadingTemplate,
      TextTemplate,
      CommentTemplate,
    ],
  },
];

export const presetTemplates = [
  {
    title: t("project.dashboard.block.template.category.preset"),
    options: [
      AverageLossesPresetTemplate,
      ProductionMonitoringPresetTemplate,
      CostImpactPresetTemplate,
      PriorityFaultEventsPresetTemplate,
      AnomalyDetectionLastWeekAlerts,
    ],
  },
];

export type BlockTemplate = (
  | typeof customTemplates
  | typeof presetTemplates
)[number]["options"][number]["block"];
